import { EmblaOptionsType } from 'embla-carousel';
import React, { useEffect } from 'react';

import { CarouselBeta, CarouselSlideBeta, H3, Skeleton } from '@zooplus/ui-components';

import { getUrlLocalised, useTranslation } from '../../hooks/use-translations';
import { useMetrics } from '../../hooks/useMetrics';
import { Brand } from '../../model/site';

import styles from './EligibleBrands.module.scss';

export type EligibleBrandsProps = {
  brands: Brand[];
};

export const EligibleBrands = (props: EligibleBrandsProps) => {
  const { t } = useTranslation();

  const metrics = useMetrics('eligible-brands');

  const options: EmblaOptionsType = {
    align: 'center',
    breakpoints: {
      '(min-width: 0px)': {
        slidesToScroll: 1,
      },
      '(min-width: 300px)': {
        slidesToScroll: 2,
      },
      '(min-width: 410px)': {
        slidesToScroll: 3,
      },
      '(min-width: 625px)': {
        slidesToScroll: 5,
      },
      '(min-width: 870px)': {
        slidesToScroll: 7,
      },
      '(min-width: 1280px)': {
        slidesToScroll: 9,
      },
      '(min-width: 1920px)': {
        slidesToScroll: 11,
      },
    },
    slidesToScroll: 3,
  };

  useEffect(() => {
    metrics.renderInit();
  }, []);

  useEffect(() => {
    if (props.brands && props.brands.length > 0) {
      metrics.renderSuccess();
    }
  }, [props.brands]);

  return (
    <section>
      <H3 className={styles.title}>{t('eligible-brands.title')}</H3>
      {props.brands && props.brands.length > 0 ? (
        <CarouselBeta
          id="eligible-brands-carousel"
          nextButtonAriaLabel="next"
          previousButtonAriaLabel="previous"
          className={styles.carouselBrands}
          emblaOptions={options}
          gap={'12px'}>
          {props.brands.map((brand) => (
            <CarouselSlideBeta
              key={`eligible-brand-${brand.brandId}`}
              data-testid={`eligible-brand-${brand.brandId}`}
              className={styles.brand}>
              <a href={getUrlLocalised(t, `${brand.brandUrl}`)}>
                <img className={styles.brandLogo} src={`${brand.brandLogoUrl}`} />
              </a>
            </CarouselSlideBeta>
          ))}
        </CarouselBeta>
      ) : (
        <Skeleton className={styles.skeleton} height={'90'} />
      )}
    </section>
  );
};
